"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_client_service_1 = require("../../axios-client/axios-client.service");
var authentication_const_1 = require("./authentication.const");
/**
 * AuthenticationService
 * @class
 */
var AuthenticationService = /** @class */ (function () {
    function AuthenticationService() {
    }
    /**
     * Authenticates provided user and returns a client token to use in HTTP calls
     * @param data {UserCredentials}
     * @returns AuthResponse
     */
    AuthenticationService.prototype.authenticate = function (data) {
        var url = authentication_const_1.AUTHENTICATION_ENDPOINT.authenticate;
        return axios_client_service_1.axiosClientInstance.post(url, data);
    };
    return AuthenticationService;
}());
/**
 * External AuthenticationService Class Instance
 * @namespace
 */
exports.authentication = new AuthenticationService();
